// src/lib/portalPageTitles.js — canonical titles for the portal's pages. A
// page's back link should read the title of the page it actually returns
// to, so each title is defined once here rather than retyped (and drifting)
// at every call site that links back to it.
export const PORTAL_MANDATES_TITLE = 'All Mandates'
export const PORTAL_CONTACTS_TITLE = 'Contacts'
export const PORTAL_SETTINGS_TITLE = 'Settings'

export function mandateOverviewTitle(mandate) {
  return `Mandate Overview: ${mandate.mandate_name}`
}

export function addNamesTitle(mandate) {
  return `Add Names: ${mandate.mandate_name}`
}
